import React, { Component } from 'react';
import { Route , Routes } from 'react-router-dom';
import './Content.min.css';
import '../menu/Menu.min.css'
import Form from '../form/Form';
import Today from "../pages/today/Today";
import Tomorrow from "../pages/tomorrow/Tomorrow";
import SevenDays from '../pages/sevenDays/SevenDays'
const APIKey = '56c04b5f168fb93229f1f0a9cf4940e7';

class Content extends Component {
    state = {
        value: '',
        err: '',
        date: '',
        city: '',
        sunrise: '',
        sunset: '',
        temp: '',
        tempMin: '',
        tempMax: '',
        tempFeels: '',
        pressure: '',
        wind: '',
        sky: '',
        icon: '',
        humidity: '',
        id: '',
        part: 'minutely,hourly',
        lat: '',
        lon: '',
             

        err2: '',
        date2: '',
        sunrise2: '',
        sunset2: '',
        temp2: '',
        tempMin2: '',
        tempMax2: '',
        tempFeels2: '',
        pressure2: '',
        wind2: '',
        sky2: '',
        icon2: '',
        humidity2: '',
        id2: '',

        err3: '',
        date3: '',
        sunrise3: '',
        sunset3: '',
        temp3: '',
        tempMin3: '',
        tempMax3: '',
        tempFeels3: '',
        pressure3: '',
        wind3: '',
        sky3: '',
        icon3: '',
        humidity3: '',
        id3: '',

        date4: '',
        sunrise4: '',
        sunset4: '',
        temp4: '',
        tempMin4: '',
        tempMax4: '',
        tempFeels4: '',
        pressure4: '',
        wind4: '',
        sky4: '',
        icon4: '',
        humidity4: '',
        id4: '',

        date5: '',
        sunrise5: '',
        sunset5: '',
        temp5: '',
        tempMin5: '',
        tempMax5: '',
        tempFeels5: '',
        pressure5: '',
        wind5: '',
        sky5: '',
        icon5: '',
        humidity5: '',
        id5: '',
       
        date6: '',
        sunrise6: '',
        sunset6: '',
        temp6: '',
        tempMin6: '',
        tempMax6: '',
        tempFeels6: '',
        pressure6: '',
        wind6: '',
        sky6: '',
        icon6: '',
        humidity6: '',
        id6: '',

        date7: '',
        sunrise7: '',
        sunset7: '',
        temp7: '',
        tempMin7: '',
        tempMax7: '',
        tempFeels7: '',
        pressure7: '',
        wind7: '',
        sky7: '',
        icon7: '',
        humidity7: '',
        id7: '',
        
      
        }

inputChange = (e) =>{
 this.setState({
   value: e.target.value
 })
 
}

formSubmit = (e)=> {
  e.preventDefault();
  let todayBelt = document.getElementById("today");
  todayBelt.classList.add("belt")
  let tomorrow = document.getElementById("tomorrow");
  tomorrow.classList.remove("belt")
  let sevenDays = document.getElementById("sevenDays");
  sevenDays.classList.remove("belt")
  
  
  const API = `http://api.openweathermap.org/data/2.5/weather?q=${this.state.value}&appid=${APIKey}&units=metric`;
  fetch(API)
  .then(response => {
    if(response.ok){
      return response;
    } else
    throw Error = ("Nie ma takiego miasta!")
  }
    )
  .then (response => response.json())
  .then ( data => {
    let time = new Date().toLocaleString();
    this.setState (preventState => ({
      err: false,
      date: time,
      sunrise: data.sys.sunrise,
      sunset: data.sys.sunset,
      temp: data.main.temp,
      tempMin: data.main.temp_min,
      tempMax: data.main.temp_max,
      tempFeels: data.main.feels_like,
      pressure: data.main.pressure,
      wind: (data.wind.speed *3.6).toFixed(1),
      sky: data.weather[0].main,
      icon: data.weather[0].icon,
      id: data.weather[0].id,
      city: preventState.value,
      humidity: data.main.humidity,
      lat:data.coord.lat,
      lon:data.coord.lon,
   
    
      
    }))
   
  })
  .catch(error => {
    console.log(error);
    this.setState(preventState => ({
      err: true,
      city: preventState.value,
      
    }))
    let todayBelt = document.getElementById("today");
    todayBelt.classList.remove("belt")
  })
}
formSubmit2 = (e) =>{
  e.preventDefault();
  let tomorrow = document.getElementById("tomorrow");
  tomorrow.classList.add("belt")
  let todayBelt = document.getElementById("today");
  todayBelt.classList.remove("belt")
  let sevenDays = document.getElementById("sevenDays");
  sevenDays.classList.remove("belt")
  
  const API = `http://api.openweathermap.org/data/2.5/onecall?lat=${this.state.lat}&lon=${this.state.lon}&exclude=${this.state.part}&appid=${APIKey}&units=metric`;
  fetch(API)
  
  .then(response => {
    
    if(response.ok){
      
      return response;
      
    } else
    throw Error = ("Nie ma takiego miasta!")
  }
    )
  .then (response => response.json())
  .then ( data => {
   
    let time = new Date();
    time.setDate(time.getDate() + 1);
    let time2 = new Date(time).toLocaleDateString();
   
    this.setState (preventState => ({
      err: false,
      date2: time2,
      sunrise2: data.daily[0].sunrise,
      sunset2: data.daily[0].sunset,
      temp2: data.daily[0].temp.day,
      tempMin2: data.daily[0].temp.min,
      tempMax2: data.daily[0].temp.max,
      tempFeels2: data.daily[0].feels_like.day,
      pressure2: data.daily[0].pressure,
      wind2: (data.daily[0].wind_speed *3.6).toFixed(1),
      icon2: data.daily[0].weather[0].icon,
      id2: data.daily[0].weather[0].id,
      city: preventState.value,
      city2: preventState.value,
      humidity2: data.daily[0].humidity,
    
      
    }))
  })

  .catch(error => {
    console.log(error);
    this.setState(preventState => ({
      err: true,
      city: preventState.value,
    }))
  })

}
formSubmit3 = (e) =>{
  e.preventDefault();
  
  let tomorrow = document.getElementById("tomorrow");
  tomorrow.classList.remove("belt");
  let todayBelt = document.getElementById("today");
  todayBelt.classList.remove("belt");
  let sevenDays = document.getElementById("sevenDays");
  sevenDays.classList.add("belt");

  const API = `http://api.openweathermap.org/data/2.5/onecall?lat=${this.state.lat}&lon=${this.state.lon}&exclude=${this.state.part}&appid=${APIKey}&units=metric`;
  fetch(API)
  
  .then(response => {
    if(response.ok){
      return response;
      
    } else
    throw Error = ("Nie ma takiego miasta!")
  }
    )
    
  .then (response => response.json())
  .then ( data => {
    let time = new Date();
    time.setDate(time.getDate() + 1);
    let time2 = new Date(time).toLocaleDateString();
    time.setDate(time.getDate() + 1);
    let time3 = new Date(time).toLocaleDateString();
    time.setDate(time.getDate() + 1);
    let time4 = new Date(time).toLocaleDateString();
    time.setDate(time.getDate() + 1);
    let time5 = new Date(time).toLocaleDateString();
    time.setDate(time.getDate() + 1);
    let time6 = new Date(time).toLocaleDateString();
    time.setDate(time.getDate() + 1);
    let time7 = new Date(time).toLocaleDateString();
    
    this.setState (preventState => ({
      err: false,
      date2: time2,
      sunrise2: data.daily[0].sunrise,
      sunset2: data.daily[0].sunset,
      temp2: data.daily[0].temp.day,
      tempMin2: data.daily[0].temp.min,
      tempMax2: data.daily[0].temp.max,
      tempFeels2: data.daily[0].feels_like.day,
      pressure2: data.daily[0].pressure,
      wind2: (data.daily[0].wind_speed *3.6).toFixed(1),
      icon2: data.daily[0].weather[0].icon,
      id2: data.daily[0].weather[0].id,
      city: preventState.value,
      humidity2: data.daily[0].humidity,
      date3: time3,
      sunrise3: data.daily[1].sunrise,
      sunset3: data.daily[1].sunset,
      tempMin3: data.daily[1].temp.min,
      tempMax3: data.daily[1].temp.max,
      pressure3: data.daily[1].pressure,
      wind3: (data.daily[1].wind_speed *3.6).toFixed(1),
      icon3: data.daily[1].weather[0].icon,
      id3: data.daily[1].weather[0].id,
      humidity3: data.daily[1].humidity,

      date4: time4,
      sunrise4: data.daily[2].sunrise,
      sunset4: data.daily[2].sunset,
      tempMin4: data.daily[2].temp.min,
      tempMax4: data.daily[2].temp.max,
      pressure4: data.daily[2].pressure,
      wind4: (data.daily[2].wind_speed *3.6).toFixed(1),
      icon4: data.daily[2].weather[0].icon,
      id4: data.daily[2].weather[0].id,
      humidity4: data.daily[2].humidity,

      date5: time5,
      sunrise5: data.daily[3].sunrise,
      sunset5: data.daily[3].sunset,
      tempMin5: data.daily[3].temp.min,
      tempMax5: data.daily[3].temp.max,
      pressure5: data.daily[3].pressure,
      wind5: (data.daily[3].wind_speed *3.6).toFixed(1),
      icon5: data.daily[3].weather[0].icon,
      id5: data.daily[3].weather[0].id,
      humidity5: data.daily[3].humidity,

      date6: time6,
      sunrise6: data.daily[4].sunrise,
      sunset6: data.daily[4].sunset,
      tempMin6: data.daily[4].temp.min,
      tempMax6: data.daily[4].temp.max,
      pressure6: data.daily[4].pressure,
      wind6: (data.daily[4].wind_speed *3.6).toFixed(1),
      icon6: data.daily[4].weather[0].icon,
      id6: data.daily[4].weather[0].id,
      humidity6: data.daily[4].humidity,

      date7: time7,
      sunrise7: data.daily[5].sunrise,
      sunset7: data.daily[5].sunset,
      tempMin7: data.daily[5].temp.min,
      tempMax7: data.daily[5].temp.max,
      pressure7: data.daily[5].pressure,
      wind7: (data.daily[5].wind_speed *3.6).toFixed(1),
      icon7: data.daily[5].weather[0].icon,
      id7: data.daily[5].weather[0].id,
      humidity7: data.daily[5].humidity, 
    }))
  })
  .catch(error => {
    console.log(error);
    this.setState(preventState => ({
      err: true,
      city: preventState.value,
    }))
  })
}
 render(){
    return(
        <div class='result'>
    
           <Routes>
            <Route path="" element={
            <Form value = {this.state.value} 
            change = {this.inputChange}
            submit = {this.formSubmit}
            />}>
                <Route index element={<Today weather={this.state} function = {this.formSubmit} />} />
                <Route path="today" element={<Today weather={this.state} function = {this.formSubmit} />} />
                <Route path="tomorrow" element= {<Tomorrow weather={this.state} function = {this.formSubmit2}  />} />
                <Route path="sevendays" element={<SevenDays weather={this.state} function = {this.formSubmit3} />}/>
              
            </Route>       
          </Routes>
        
       </div>
       
    )
}
}
export default Content;